module.exports = "https://www.gc-qa.gnp.com.mx/595496443bfe96d1b887a79a35f35b3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/time.svg
// module id = 1864
// module chunks = 0